import { SIGN_OUT } from 'Global/Stores/auth'

const PREVIEW_EXPANSION_TOGGLE = 'PREVIEW_MODAL/MAIN/EXPANSION/TOGGLE'
const PREVIEW_TOGGLE = 'PREVIEW_MODAL/MAIN/PREVIEW/TOGGLE'

export const togglePreview = rugType => ({
  payload: typeof rugType === 'string' ? rugType : '',
  type: PREVIEW_TOGGLE,
})

export const toggleExpansion = () => ({
  type: PREVIEW_EXPANSION_TOGGLE,
})

const initialState = {
  expanded: false,
  rugType: '',
  visible: false,
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
    case PREVIEW_EXPANSION_TOGGLE:
      return {
        ...state,
        expanded: !state.expanded,
      }

    case PREVIEW_TOGGLE:
      return {
        ...state,
        expanded: false,
        visible: !state.visible,
        rugType: payload,
      }

    case '@@router/LOCATION_CHANGE':
      return initialState

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
